import { InjectionToken } from '@angular/core';

/**
 * The new shell of the call-centre (the header and the menu of the canvas «Шапка и меню — редизайн», 20.10) and the theme switch — ONE switch, like `WORKPLACE_READY`: `true` — `HomeComponent` draws the new shell
 * (`ShellHeaderComponent`, `ShellSidebarComponent`), the pages follow the theme; `false` — the Metronic header, menu and footer, as they were, and every page is light.
 *
 * On in every build, production included (the owner accepted the new shell).
 */
export const SHELL_V2_READY = true;

/** The same switch as a token: a spec gives its own value and proves both cases. */
export const SHELL_V2_ENABLED = new InjectionToken<boolean>('cc.shell.v2Enabled', { providedIn: 'root', factory: () => SHELL_V2_READY });

/**
 * Route data of a page that follows the theme: the new pages of the call-centre opt in. Everything not marked — the pages still on Metronic («Старые страницы»), the shared pages of the libraries — stays light
 * whatever the theme (only the shell follows it there): an old page that went dark by mistake would be white text on its white portlets.
 */
export interface ShellRouteData {
  themed?: boolean;
}

export const THEMED_PAGE: ShellRouteData = { themed: true };
